import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * CORE-10 patient self-report form entrypoint.
 *
 * We pass `formKey="core10"` explicitly so the template binds to the correct
 * form definition in Firestore.
 */
export default function PatientCORE10Form() {
  return (
    <PatientFormTemplate
      formTitle="Clinical Outcomes in Routine Evaluation (CORE-10)"
      formKey="core10"
    />
  );
}

